export class SocialUser {
  provider: string;
  id: string;
  email: string;
  authToken: string;
  name: string;
  photoUrl: string;
  firstName: string;
  lastName: string;

  response?: any;
}
